<template>
  <div
    class="video-container"
    :style="{ 'background-image': `url(${$config.get('background')})` }"
  >
    <div id="youtube-player"></div>
  </div>
</template>
<script>
import { youtubeParser } from "@/functions/helpers";

export default {
  props: {
    url: {
      type: String,
      default: ""
    },
    thumb: {
      type: String,
      default: ""
    }
  },
  mounted() {
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      new YT.Player("youtube-player", {
        height: "1080",
        width: "1920",
        videoId: youtubeParser(this.url),
        events: {
          onReady: event => {
            event.target.mute();
            event.target.playVideo();
          },
          onStateChange: event => {
            if (event.data === 0) {
              event.target.playVideo();
            }
          }
        },
        rel: 0,
        playerVars: {
          wmode: "opaque",
          autoplay: 1,
          mute: 1,
          controls: 0,
          loop: 1,
          rel: 0,
          showinfo: 0,
          enablejsapi: 1,
          playsinline: 1,
          disablekb: 1,
          modestbranding: 1,
          fs: 0,
          iv_load_policy: 3,
          autohide: 0
        },
        origin: window.location.host
      });
    };
  }
};
</script>
<style lang="scss" scoped>
.video-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-size: cover;
  background-position: center;

  ::v-deep iframe {
    position: absolute;
    top: -100px;
    left: 0;
    width: 100%;
    height: calc(100% + 200px);
  }
}
</style>
